module.exports = __webpack_public_path__ + "img/eye-icon.408b9832.svg";